module.exports = __webpack_public_path__ + "img/title.f40fe880.png";